/**
 * Retired names.
 *
 * An excavated dinosaur has its name written on a plaque in the Museum, and
 * a name on a plaque belongs to the one in the case: it cannot be given
 * again for the rest of the game. That is the whole of what excavating
 * costs — it carries no production, so what the choice spends is the name.
 *
 * Reserved names are derived from the era log rather than stored, so there is
 * one place a name can be retired and no second list to keep in step.
 */

import type { GameState } from './state';

/**
 * Names match on case and surrounding space, so "invisible" cannot slip past
 * a retired "Invisible". Everything else is left alone: two names that differ
 * by a character are two names.
 */
export function normaliseName(name: string): string {
  return name.trim().toLowerCase();
}

/** Every name the Museum has on a plaque, normalised for comparison. */
export function retiredNames(state: GameState): Set<string> {
  const out = new Set<string>();
  for (const row of state.eraLog) {
    if (row.excavatedName !== null) out.add(normaliseName(row.excavatedName));
  }
  return out;
}

/** Whether this name is already on a plaque. Blank is never reserved. */
export function isNameRetired(state: GameState, name: string): boolean {
  const key = normaliseName(name);
  if (key === '') return false;
  return retiredNames(state).has(key);
}

/**
 * The name a plaque holds, spelled the way it was given — for saying which
 * name is taken rather than just that it is.
 */
export function retiredSpelling(state: GameState, name: string): string | null {
  const key = normaliseName(name);
  for (const row of state.eraLog) {
    if (row.excavatedName !== null && normaliseName(row.excavatedName) === key) {
      return row.excavatedName;
    }
  }
  return null;
}
